export default __webpack_public_path__ + "static/media/district.7ad90506.svg";